import { bindProduct, defineProduct } from '@wtfalch/design';
import { GOOD_COMPANY, HOUSE_DEFAULT_THEME, HOUSE_THEMES } from '@wtfalch/house';
import { ARCH } from './marks.ts';

/**
 * Agora's own product.
 *
 * Three layers. `@wtfalch/design` is the system. `@wtfalch/house` is the
 * identity and the palette -- Good Company, the look the whole estate wears.
 * This file is the third: the mark, which is the one thing Agora does not
 * share with Boule.
 *
 * It replaces `theme.ts`, which held Line Map: map grey, enamel white, and
 * Overpass. That was this app's own look, drawn before the estate had one.
 *
 * **A company's colour is not a theme.** `agoras.ts` carries `theme.accent`
 * per Agora and `shell/Frame.tsx` draws it as that company's line. Nothing
 * here touches it, and nothing else is allowed to borrow it.
 */
export const product = defineProduct({
  name: 'Agora',
  mark: ARCH,
  identity: GOOD_COMPANY,
  themes: HOUSE_THEMES,
  defaultTheme: HOUSE_DEFAULT_THEME,
});

export const { Brand, THEMES, applyTheme } = bindProduct(product);
